import axios from "./axios";

  const obtenerAlmacenes = async ({ page, limit, filters = '' } = {},  token, tokenCompany) => {
    axios.defaults.headers.common['token'] = token;
      axios.defaults.headers.common['empresa'] = tokenCompany;
      axios.defaults.headers.common['cache'] = 'no-cache';
      axios.defaults.headers.common['pragma'] = 'no-cache';
      axios.defaults.headers.common['cache-control'] = 'no-cache';
      if (!page || !limit)
        return axios.get(`${process.env.REACT_APP_API}business/api/almacen/getAlmacenEmpresa`).then(res => res.data)
      return axios.get(`${process.env.REACT_APP_API}business/api/almacen/getAlmacenEmpresa?page=${page}&limit=${limit}&filter=${filters}`).then(res => res.data)
      

  }
  
  const getAlmacenesAdmin = async ({ page, limit, filters = '' } = {},  token, tokenCompany) => {
    axios.defaults.headers.common['token'] = token;
      axios.defaults.headers.common['empresa'] = tokenCompany;
      axios.defaults.headers.common['cache'] = 'no-cache';
      axios.defaults.headers.common['pragma'] = 'no-cache';
      axios.defaults.headers.common['cache-control'] = 'no-cache';
      if (!page || !limit)
        return axios.get(`${process.env.REACT_APP_API}business/api/almacen/getAlmacen`).then(res => res.data)      

  }

  const listarUsuarios = async (token, tokenCompany) => {
    axios.defaults.headers.common['token'] = token
    axios.defaults.headers.common['empresa'] = tokenCompany
    axios.defaults.headers.common['cache'] = 'no-cache'
    axios.defaults.headers.common['pragma'] = 'no-cache'
    axios.defaults.headers.common['cache-control'] = 'no-cache'
    return axios.get(`${process.env.REACT_APP_API}business/api/usuario`).then(res => res.data)
}

const listarAlmacenes = async (token, tokenCompany) => {
    axios.defaults.headers.common['token'] = token
    axios.defaults.headers.common['empresa'] = tokenCompany
    axios.defaults.headers.common['cache'] = 'no-cache'
    axios.defaults.headers.common['pragma'] = 'no-cache'
    axios.defaults.headers.common['cache-control'] = 'no-cache'
    return axios.get(`${process.env.REACT_APP_API}business/api/usuario/almacenes`).then(res => res.data)
}

const listarEmpresas = () => {
    return fetch(`${process.env.REACT_APP_API}business/api/usuario/empresas`, {
        method: 'GET'
    }).then(res => res.json())
}



const listarCorreos = (token, tokenCompany) => {
    axios.defaults.headers.common['token'] = token
    axios.defaults.headers.common['empresa'] = tokenCompany
    axios.defaults.headers.common['cache'] = 'no-cache'
    axios.defaults.headers.common['pragma'] = 'no-cache'
    axios.defaults.headers.common['cache-control'] = 'no-cache'
    return axios.get(`${process.env.REACT_APP_API}business/api/usuario/correos`).then(res => res.data)
}

const listarTecnicos = async ({},token, tokenCompany) => {
    axios.defaults.headers.common['token'] = token
    axios.defaults.headers.common['empresa'] = tokenCompany
    axios.defaults.headers.common['cache'] = 'no-cache'
    axios.defaults.headers.common['pragma'] = 'no-cache'
    axios.defaults.headers.common['cache-control'] = 'no-cache'
    return axios.get(`${process.env.REACT_APP_API}business/api/usuario/tecnicos`).then(res => res.data)
}

const listarUsuarioPorRol = async (idProfile, token) => {
    const idApp = process.env.REACT_APP_ID_APP;

    return axios.post(
        `${process.env.REACT_APP_SECURITY_API}/api/external/usersByProfile/${idApp}`,
        {
            id_profile: idProfile
        },
        {
            headers: {
                'x-access-token': token
            }
        }
    ).then(res => res.data);
};

const listarUsuariosEmpresa = (token, tokenCompany) => {
    return axios.get(
        `${process.env.REACT_APP_API}business/api/usuario/UsuariosEmpresa`,
        {
            headers: {
                'Content-Type': 'application/json',
                token,
                empresa: tokenCompany,
                cache: 'no-cache',
                pragma: 'no-cache',
                'cache-control': 'no-cache'
            }
        }
    ).then(res => res.data);
};

const obtenerPerfiles = (token) => {
    const idApp = process.env.REACT_APP_ID_APP;

    return axios.post(
        `${process.env.REACT_APP_SECURITY_API}/api/external/getProfile/${idApp}`,
        { id_app: idApp },
        {
            headers: {
                'x-access-token': token
            }
        }
    ).then(res => res.data);
};

const obtenerPerfilesUsuario = (usuarioId, token) => {
    const idApp = process.env.REACT_APP_ID_APP;

    return axios.post(
        `${process.env.REACT_APP_SECURITY_API}/api/external/getUserProfiles/${idApp}`,
        { id_user: usuarioId },
        {
            headers: {
                'x-access-token': token
            }
        }
    ).then(res => res.data);
};

const actualizarPerfilesUsuario = (usuarioId, idsProfiles, token) => {
    const idApp = process.env.REACT_APP_ID_APP;

    return axios.put(
        `${process.env.REACT_APP_SECURITY_API}/api/external/updateUserProfiles/${idApp}`,
        {
            id_user: usuarioId,
            idsProfiles
        },
        {
            headers: {
                'x-access-token': token
            }
        }
    ).then(res => res.data);
};

const actualizarEstadoTecnico = (
    usuarioId,
    esTecnico,
    token,
    tokenCompany
) => {
    return axios.post(
        `${process.env.REACT_APP_API}business/api/usuario/tecnicos`,
        {
            IdUsuario: usuarioId,
            isTecnico: esTecnico
        },
        {
            headers: {
                token,
                empresa: tokenCompany
            }
        }
    ).then(res => res.data);
};

export {
    listarUsuarios,
    listarAlmacenes,
    listarEmpresas,
    listarCorreos,
    obtenerAlmacenes,
    getAlmacenesAdmin,
    listarUsuarioPorRol,
    listarTecnicos,
    listarUsuariosEmpresa,
    obtenerPerfiles,
    obtenerPerfilesUsuario,
    actualizarPerfilesUsuario,
    actualizarEstadoTecnico
};
